export var createCollection = function createCollection(properties) {
  return Object.keys(properties).map(function (key) {
    return {
      path: key,
      type: properties[key]
    };
  });
};